import React, { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: 328,
  },
  hiddenNumber: {
    top: 15,
    right: 5,
    width: 70,
    height: 30,
    zIndex: 10,
    position: 'absolute',
    background: 'white',
    [theme.breakpoints.down("600")]: {
      display: 'none',
    }
  },
}));

export default function CustomizedInputs(
  { 
    input, 
    meta: { touched, error, warning, invalid }, 
    ...props}
  ) {
  const classes = useStyles();
  const {defaultValue} = props;

  useEffect(() => {
    if (defaultValue) {
      input.onChange("0");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue])

  return (
    <div className={classes.root}>
        <div className={classes.hiddenNumber}></div>
        <TextField
          disabled={props.disabled}
          className={classes.inputStyle}
          label={props.placeholder}
          error={touched && invalid}
          helperText={touched && error}
          value={defaultValue ? "0" : input.value}
          {...input}
          {...props}
        />
      {touched &&
        ((error && <span>{error.phone}</span>) ||
          (warning && <span>{warning.phone}</span>))}
      </div>
  )
};